import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import reportServices from '../reportServices'
import moment from 'moment'
import { useAppData } from '../../../../../context/AppDataContext';
import DateSelect from '../../../../../components/AppInput/DateSelect';

function NotesReportPage() {

    const [filter,setFilter] = useState(null);
    const [notesData,setNotesData] = useState(null);
    const {projectDD,getDDDataById} = useAppData();

    const getNotesData = () => {
        reportServices.getNotesData(filter).then(res=>{
            setNotesData(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
        })
    }

    useEffect(()=>{
        getNotesData()
    },[filter])

    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <span className='float-end'><DateSelect setFilter={setFilter} filter={filter}/></span>
                    </div>
                </div>
                {notesData &&
                    <div className='row'>
                        <div className='col-md-6'>
                            {notesData?.map(note=>
                                <div key={note.id}>
                                    <span className='text-success'>{moment(note.created_at).fromNow()}</span>
                                    <div className='card mb-1'>
                                        <div className='card-body p-2'>
                                            <div>{note.note}</div>
                                        </div>
                                    </div>
                                    <div style={{fontSize:10}}>
                                        <span className='float-end'  >{moment(note.created_at).format("LLLL")}</span>
                                        <span className='fw-bold float-end  me-2'>{getDDDataById(projectDD,note.projectId).label}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='col-md-6'>
                            
                        </div>
                    </div>
                }
            </div>
        </AppLayout>
    )
}

export default NotesReportPage